console.log('Product Tabs Script Loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM Content Loaded');
  
  // Tab functionality for product-tabs-info section
  var tabsSection = document.querySelector('.section-product-tabs-info');
  if (tabsSection) {
    console.log('Tabs section found');
    
    var tabButtons = tabsSection.querySelectorAll('.tab-btn');
    console.log('Tab buttons found:', tabButtons.length);
    
    tabButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Tab button clicked:', button.textContent);
        
        var onclickAttr = button.getAttribute('onclick');
        if (onclickAttr) {
          var match = onclickAttr.match(/\('([^']+)'\)/);
          if (match && match[1]) {
            var tabId = match[1];
            console.log('Extracted tab ID:', tabId);
            
            var allTabs = tabsSection.querySelectorAll('.tab-btn');
            var allPanes = tabsSection.querySelectorAll('.tab-content-pane');
            
            allTabs.forEach(function(tab) {
              tab.classList.remove('active');
            });
            allPanes.forEach(function(pane) {
              pane.classList.remove('active');
            });
            
            button.classList.add('active');
            var targetPane = document.getElementById(tabId);
            if (targetPane) {
              targetPane.classList.add('active');
              console.log('Tab switched successfully');
            }
          }
        }
      });
    });
  }
  
  // Nutrition button functionality for nutrition-facts section
  var nutritionSection = document.querySelector('.section-nutrition-facts');
  if (nutritionSection) {
    console.log('Nutrition section found');
    
    var nutritionButton = nutritionSection.querySelector('.btn-view-label');
    console.log('Nutrition button found:', nutritionButton);
    
    if (nutritionButton) {
      nutritionButton.addEventListener('click', function(e) {
        e.preventDefault();
        console.log('Nutrition button clicked');
        
        var wrapper = this.closest('.sb-nutrition-wrapper');
        if (!wrapper) {
          console.log('Wrapper not found');
          return;
        }
        
        var additionalRows = wrapper.querySelectorAll('.additional-nutrition');
        var isExpanded = wrapper.classList.contains('expanded');
        
        console.log('Additional rows found:', additionalRows.length);
        console.log('Is expanded:', isExpanded);
        
        additionalRows.forEach(function(row) {
          if (isExpanded) {
            row.style.setProperty('display', 'none', 'important');
          } else {
            row.style.setProperty('display', 'table-row', 'important');
          }
        });
        
        wrapper.classList.toggle('expanded');
        
        var svg = this.querySelector('svg');
        if (svg) {
          svg.style.transform = isExpanded ? 'rotate(0deg)' : 'rotate(180deg)';
        }
        
        var btnText = this.querySelector('.btn-text');
        if (btnText) {
          if (isExpanded) {
            btnText.textContent = btnText.textContent.replace('Hide Full', 'View Full');
            console.log('Collapsed nutrition label');
          } else {
            btnText.textContent = btnText.textContent.replace('View Full', 'Hide Full');
            console.log('Expanded nutrition label');
          }
        }
      });
    }
  }
  
  console.log('Event listeners attached successfully');
});
